// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".public-DraftEditorPlaceholder-root{position:absolute}.editor{cursor:text}", "",{"version":3,"sources":["webpack://components/Editor/index.scss"],"names":[],"mappings":"AAGA,oCACE,iBAAA,CAGF,QACE,WAAA","sourcesContent":["\n// HACK to postition the cursor and the placeholder\n// at the right position\n.public-DraftEditorPlaceholder-root {\n  position: absolute;\n}\n\n.editor {\n  cursor: text;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
